import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { HTMLBindingDirective } from '@df/ui/common/html-binding.directive';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PricePipe } from '@df/ui/price/price.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { strapsUpsellCarouselAbConfig } from '../../../../../basket/straps-upsell-carousel/basket-straps-upsell-carousel.component';
import { ProductPriceComponent } from '../../../../../ui/price/product-price.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { WishlistToggleComponent } from '../../../wishlist/toggle/wishlist-toggle.component';
import { ProductDeliveryMessagesComponent } from '../../delivery/messages/product-delivery-messages.component';
import { IParentView } from '../layout/product-view-layout.abstract';
import { IProductViewLayoutContent } from '../layout/product-view-layout.interface';
import { ProductViewReviewsComponent } from '../reviews/product-view-reviews.component';
import { ProductViewWishlistComponent } from '../wishlist/product-view-wishlist.component';

@Component({
    selector: 'product-view-name',
    templateUrl: './product-view-name.component.html',
    styleUrl: './product-view-name.scss',
    standalone: true,
    imports: [
        CommonModule,
        HTMLBindingDirective,
        ICmsClientModule,
        OptionLabelPipe,
        PricePipe,
        ProductDeliveryMessagesComponent,
        ProductPriceComponent,
        ProductViewReviewsComponent,
        ProductViewWishlistComponent,
        TranslatePipe,
        WishlistToggleComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewNameComponent extends UiComponent {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV3>;

    @Input({ required: true })
    parentView!: IParentView;

    @Input()
    parent: ProductDecorator<IProductDataV3>;

    @Input()
    content: IProductViewLayoutContent;

    @Input()
    showKlarna: boolean;

    override ngOnInit() {
        this.subscriptions.add(this.parentView.detectChanges$.subscribe(() => this.detectChanges()));

        super.ngOnInit();
    }

    get abShowCondition(): string {
        return `(${strapsUpsellCarouselAbConfig.experimentName}) ${strapsUpsellCarouselAbConfig.showFor}`;
    }
}
